import { useMemo } from 'react';
import type { ChartPoint } from '~/common/charts/types';
import type { MapFulfillmentRequest } from '~/common/types';
import SimpleBarChart from '~/components2/dashboard/charts/SimpleBarChart';

type G = { [key: string]: number };

export default function Charts({ data }: { data: MapFulfillmentRequest[] }) {
  const chartData = useMemo<{
    byDay: ChartPoint[];
    byOrg: ChartPoint[];
  }>(() => {
    const groupedByDay: G = {};
    const groupedByOrg: G = {};

    data.forEach((req) => {
      // add to day
      const d = req.createdAt.toLocaleString()!;
      groupedByDay[d] = (groupedByDay[d] || 0) + 1;

      // add to org
      const org = req.requestor?.organization || 'Unknown';
      groupedByOrg[org] = (groupedByOrg[org] || 0) + 1;
    });

    const byDay: ChartPoint[] = Object.keys(groupedByDay)
      .sort((a, b) => a.localeCompare(b))
      .map((day) => ({
        key: day,
        value: groupedByDay[day],
      }));

    // sort the orgs by number of requests and grab first five if needed
    const byOrg: ChartPoint[] = Object.keys(groupedByOrg)
      .sort((a, b) => groupedByOrg[b] - groupedByOrg[a])
      .splice(0, 5)
      .map((org) => ({ key: org, value: groupedByOrg[org] }));

    return { byOrg, byDay };
  }, [data]);

  return (
    <div className="grid grid-cols-2 gap-2">
      <div className="col-span-1 h-72">
        <SimpleBarChart data={chartData.byDay} title="Requests Over Time" yAxisLabel="Number of Requests" />
      </div>

      <div className="col-span-1 h-72">
        <SimpleBarChart data={chartData.byOrg} title="Requests by Organization" yAxisLabel="Number of Requests" />
      </div>
    </div>
  );
}
